import Component from "../../lib/Component.js";
import ScrollInView from "./ScrollInView.js";

const AdSenseAds = ({ preloadScriptId }) => {
  let mounted = false;

  const initializeAdsense = async () => {
    return new Promise((resolve, reject) => {
      const adSenseScriptPreload = document.getElementById(preloadScriptId);
      if (adSenseScriptPreload) {
        const adSenseScript = document.createElement("script");
        adSenseScript.async = true;
        adSenseScript.crossOrigin = "anonymous";
        document.querySelector("body").appendChild(adSenseScript);
        adSenseScript.onload = () => {
          resolve(window.adsbygoogle);
        };
        adSenseScript.onerror = () => {
          reject(new Error("Failed to load AdSense script"));
        };
        adSenseScript.src = adSenseScriptPreload.href;
      }
    });
  };

  const adsInView = ScrollInView({
    observables: document.querySelectorAll(".adsbygoogle-lazy"),
    unobserveOnEnter: true,
    options: {
      rootMargin: "400px", // Load ads 400px before they enter viewport
    },
    onEnter: (adZone) => {
      try {
        adZone.className = "adsbygoogle";
        (window.adsbygoogle = window.adsbygoogle || []).push({});
      } catch (error) {
        if (process.env.NODE_ENV === "development") console.error("Failed to load AdSense ad:", error);
      }
    },
  });

  return new Component({
    onMount: () => {
      if (mounted) return;
      mounted = true;

      adsInView.mount();

      if (process.env.NODE_ENV === "development") {
        console.log("[AdSense Test Mode] Initializing...");

        const handleNextAdZone = () => {
          const emptyZone = document.querySelector(".adsbygoogle:not(.ad-placeholder)");
          if (emptyZone) {
            console.log(
              "[AdSense Test Mode]",
              emptyZone.dataset.adSlot,
              Array.from(emptyZone.parentElement.classList).filter((cn) => cn.startsWith("ad-"))[0]
            );
            const adZonePlaceholder = document.createElement("ins");
            adZonePlaceholder.className = "adsbygoogle ad-placeholder";
            adZonePlaceholder.innerHTML = `[AdSense Test Mode] Ad Slot: ${emptyZone.dataset.adSlot}`;
            emptyZone.replaceWith(adZonePlaceholder);
          }
        };

        window.adsbygoogle = window.adsbygoogle || [];
        if (Array.isArray(window.adsbygoogle)) {
          window.adsbygoogle.forEach(() => handleNextAdZone());
          window.adsbygoogle = { push: handleNextAdZone };
        }
        return;
      }

      initializeAdsense().catch((error) => {
        if (process.env.NODE_ENV === "development") console.error("Failed to initialize AdSense:", error);
        // TODO: handle ad blockers
      });
    },
    onUnmount: () => {
      if (!mounted) return;
      mounted = false;

      adsInView.unmount();
    },
  });
};

export default AdSenseAds;
